import { render, staticRenderFns } from "./ReplacementForm.vue?vue&type=template&id=7aff2260&scoped=true&"
import script from "./ReplacementForm.vue?vue&type=script&lang=js&"
export * from "./ReplacementForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementForm.vue?vue&type=style&index=0&id=7aff2260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff2260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aff2260')) {
      api.createRecord('7aff2260', component.options)
    } else {
      api.reload('7aff2260', component.options)
    }
    module.hot.accept("./ReplacementForm.vue?vue&type=template&id=7aff2260&scoped=true&", function () {
      api.rerender('7aff2260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/ReplacementForm.vue"
export default component.exports